/* ============================================================
   NAJNIZJA CENA / SIDRENA CIJENA NA PDP-u (apifood-hero-pp forma)
   apipet.com (SLO), 28.9.2026. - ista skripta kao na apipet.eu
   ------------------------------------------------------------
   Podaci: app "sidrena-cijena-apipet-si", /apps/cjenik/sidrene.json
   (endpoint se cita s app skripte sidrena-svugdje.js), po odabranoj
   varijanti (input name="id" u formi).
   SLO instanca appa ima mapa.sidrena = false (redak s datumom skriva
   inline stilom). Odluka 28.9.2026: na apipet.com se sidrena ipak
   prikazuje (PRIKAZI_SIDRENU) - CSS otkriva appove retke
   (assets/apipet-sidrena.css, 5), a ova skripta im prevodi oznaku:
   "Cijena 10.9.2026." -> "Cena 10. 9. 2026" (prevedi()).
   "Najnizja cena v zadnjih 30 dneh" (mapa.oznakaNajniza, vec slovenski)
   ide samo uz snizenu cijenu (prekrizena cijena u gumbu / opciji ili
   aktivno pakiranje s compare cijenom, npr. 120 kapsul -12%).
   Gdje se prikazuje:
     - proizvod s pretplatom (Loop widget vidljiv): ispod cijene u svakoj
       opciji kupovine
     - inace: ispod gumba "Dodaj v kosarico"
   Appov PDP redak (.sc-sidrena--pdp) forma s klasom .ap-sidrena-vlastita
   skriva (assets/apipet-sidrena.css): app ga stavi uz "najdublju" cijenu
   i ne prepoznaje prekrizenu cijenu u gumbu (inline line-through), pa na
   PDP-u najnizja cena za snizena pakiranja nije bila vidljiva.
   Greska u dohvatu ili varijanta bez zapisa: klasa se ne stavlja, vrijedi
   appov prikaz.
   Revert = makni <script> za ovaj file iz snippets/meta-tags.liquid.
   ============================================================ */
(function () {
  var BLOK = 'ap-sidrena-blok';
  var zakazano = false;
  var mapa = null;
  var ucitavanje = null;
  var PRIKAZI_SIDRENU = true; // false = kao app: samo najnizja cena uz snizene
  var SLO = (document.documentElement.lang || '').indexOf('sl') === 0;

  /** "Cijena 10.9.2026.:" -> "Cena 10. 9. 2026:" (samo na slovenskom). */
  function prevedi(t) {
    if (!SLO) return t;
    var m = /^\s*Cijena\s+(\d{1,2})\.\s*(\d{1,2})\.\s*(\d{4})\.?\s*(:?)\s*$/.exec(t);
    return m ? 'Cena ' + parseInt(m[1], 10) + '. ' + parseInt(m[2], 10) + '. ' + m[3] + m[4] : t;
  }

  /** Appovi retci (kartice, navigacija, Rebuy, kosarica): otkrij i prevedi. */
  function appRetci() {
    var r = document.querySelectorAll('.sc-sidrena');
    for (var i = 0; i < r.length; i++) {
      var el = r[i];
      if (el.closest('.' + BLOK)) continue;
      if (PRIKAZI_SIDRENU && el.getAttribute('aria-hidden') === 'true') el.removeAttribute('aria-hidden');
      var l = el.querySelector('.sc-sidrena__label');
      if (l) {
        var p = prevedi(l.textContent);
        if (p !== l.textContent) l.textContent = p;
      }
    }
  }

  function endpoint() {
    var s = document.querySelector('script[src*="sidrena-svugdje"][data-endpoint]');
    return s ? s.dataset.endpoint : null;
  }

  function ucitaj() {
    if (mapa || ucitavanje) return;
    var url = endpoint();
    if (!url) return;
    ucitavanje = fetch(url)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (j && j.aktivno && j.cijene) { mapa = j; zakazi(); }
      })
      .catch(function () {})
      .then(function () { ucitavanje = null; });
  }

  function vidljiv(el) {
    return !!el && el.getClientRects().length > 0;
  }

  /** Ima li unutar elementa vidljiva prekrizena cijena. */
  function prekrizeno(el) {
    if (!el) return false;
    var s = el.querySelectorAll('s, del, [class*="compare"], [class*="strike"], [style*="line-through"]');
    for (var i = 0; i < s.length; i++) if (vidljiv(s[i])) return true;
    return false;
  }

  /** Je li odabrano pakiranje prikazano kao snizeno. */
  function snizenoPakiranje(f, gumb) {
    if (prekrizeno(gumb)) return true;
    var k = f.querySelector('.b-card.active[data-price][data-compare-price]');
    return !!k && Number(k.getAttribute('data-compare-price')) > Number(k.getAttribute('data-price'));
  }

  function oznakaNajniza() {
    if (mapa.oznakaNajniza) return mapa.oznakaNajniza;
    return (document.documentElement.lang || '').indexOf('sl') === 0
      ? 'Najnižja cena v zadnjih 30 dneh'
      : 'Najniža cijena u zadnjih 30 dana';
  }

  function redak(oznaka, vrijednost, najniza) {
    var d = document.createElement('div');
    d.className = 'sc-sidrena ap-sidrena' + (najniza ? ' ap-sidrena--najniza' : '');
    var l = document.createElement('span');
    l.className = 'sc-sidrena__label';
    l.textContent = oznaka + ':';
    var v = document.createElement('span');
    v.className = 'sc-sidrena__value';
    v.textContent = vrijednost;
    d.appendChild(l);
    d.appendChild(v);
    return d;
  }

  /**
   * Blok s retcima odmah iza elementa `iza`; prepisuje se samo kad se
   * sadrzaj promijeni. Bez ijednog retka (SLO, cijena nije snizena) bloka nema.
   */
  function postavi(blok, iza, klasa, oznaka, zapis, najniza) {
    var sSidrenom = PRIKAZI_SIDRENU || mapa.sidrena !== false;
    if (!sSidrenom && !najniza) { if (blok) blok.remove(); return; }
    if (!blok) {
      blok = document.createElement('div');
      blok.className = klasa;
    }
    if (blok.previousElementSibling !== iza) iza.insertAdjacentElement('afterend', blok);
    var kljuc = [sSidrenom ? oznaka + zapis.c : '', najniza ? zapis.n : ''].join('|');
    if (blok.getAttribute('data-k') !== kljuc) {
      blok.setAttribute('data-k', kljuc);
      blok.textContent = '';
      if (sSidrenom) blok.appendChild(redak(oznaka, zapis.c, false));
      if (najniza) blok.appendChild(redak(oznakaNajniza(), zapis.n, true));
    }
  }

  function sync() {
    zakazano = false;
    appRetci();
    var forme = document.querySelectorAll('form.api-product-form');
    if (!forme.length) return;
    if (!mapa) ucitaj();

    for (var i = 0; i < forme.length; i++) {
      var f = forme[i];
      var polje = f.querySelector('[name="id"]');
      var zapis = mapa && polje ? mapa.cijene[polje.value] : null;
      var gumb = f.querySelector('.apipet-btn-primary');
      var opcije = f.querySelectorAll('.loop-widget-purchase-option');
      var uLoopu = [].some.call(opcije, vidljiv);
      var ok = !!(zapis && zapis.c && (uLoopu || gumb));

      if (f.classList.contains('ap-sidrena-vlastita') !== ok) {
        f.classList.toggle('ap-sidrena-vlastita', ok);
      }

      var oznaka = ok ? prevedi(zapis.o || mapa.oznaka || '') : '';
      var snizenaVarijanta = ok && snizenoPakiranje(f, gumb);

      // 1) opcije kupovine (pretplata)
      for (var j = 0; j < opcije.length; j++) {
        var opcija = opcije[j];
        var glava = opcija.querySelector(':scope > .loop-widget-purchase-option-header');
        var blok = opcija.querySelector(':scope > .' + BLOK);
        if (!ok || !uLoopu || !glava) { if (blok) blok.remove(); continue; }
        var najniza = (prekrizeno(opcija) || snizenaVarijanta) && zapis.n;
        postavi(blok, glava, BLOK, oznaka, zapis, najniza);
      }

      // 2) ispod gumba (bez pretplate)
      var gBlok = f.querySelector('.' + BLOK + '--gumb');
      if (!ok || uLoopu || !gumb) {
        if (gBlok) gBlok.remove();
      } else {
        postavi(gBlok, gumb, BLOK + ' ' + BLOK + '--gumb', oznaka, zapis, snizenaVarijanta && zapis.n);
      }
    }
  }

  function zakazi() {
    if (zakazano) return;
    zakazano = true;
    // setTimeout, ne requestAnimationFrame: rAF stoji dok je kartica u pozadini
    setTimeout(sync, 30);
  }

  function pokreni() {
    sync();
    if (!window.MutationObserver) return;
    new MutationObserver(function (promjene) {
      for (var i = 0; i < promjene.length; i++) {
        var t = promjene[i].target;
        var el = t.nodeType === 1 ? t : t.parentElement;
        // vlastite izmjene ne pokrecu novi krug
        if (el && el.closest && el.closest('.' + BLOK)) continue;
        // od promjena klase/stila zanimaju nas samo Loop widget i pakiranja
        if (promjene[i].type === 'attributes' &&
            !/loop-widget|b-card/.test(String((el && el.className) || ''))) continue;
        zakazi();
        return;
      }
    }).observe(document.body, {
      childList: true, subtree: true, characterData: true,
      attributes: true, attributeFilter: ['class', 'style']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pokreni);
  } else {
    pokreni();
  }
})();